import jwtDecode from "jwt-decode";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

export const IAM_PARTNER_ACCESS_MESSAGE =
  "You can add or edit users only for your assigned partners.";

export const IAM_SHOWROOM_ACCESS_MESSAGE =
  "You can manage showrooms only for your assigned partners.";

const getLoginToken = () =>
  localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

export const isIAMOnlyUser = () => {
  const token = getLoginToken();
  return Boolean(
    token?.scope?.includes("ROLE_IAM") &&
      !(
        token?.scope?.includes("ROLE_ADMIN") ||
        token?.scope?.includes("ROLE_MD") ||
        token?.scope?.includes("ROLE_SOPDIR")
      )
  );
};

export const getIAMPartnerIds = async () => {
  const token = getLoginToken();
  const resourceUrl = process.env.REACT_APP_RESOURCE_API_KEY_URL;
  const territoryUrl = `${resourceUrl}${oAuthServiceConfig.territoryList}/search/findAllByAreaManagerContains?email=${encodeURIComponent(
    token?.email
  )}`;
  const territories = await OAuthService.getList(territoryUrl);
  const territoryIds =
    territories?.data?._embedded?.territories?.map((item) => item.id) || [];
  if (!territoryIds.length) {
    return [];
  }
  const query = territoryIds.map((id) => `territories=${id}`).join("&");
  const companies = await OAuthService.getList(
    `${resourceUrl}${oAuthServiceConfig.companies}/search/findByTerritoryIn?${query}`
  );
  return (companies?.data?._embedded?.companies || []).map((company) =>
    String(company?._links?.company?.href?.split("/").pop())
  );
};

export const canIAMManagePartner = async (partnerId) => {
  if (!isIAMOnlyUser()) {
    return true;
  }
  if (partnerId === undefined || partnerId === null || partnerId === "") {
    return false;
  }
  try {
    const partnerIds = await getIAMPartnerIds();
    return partnerIds.includes(String(partnerId));
  } catch (error) {
    return false;
  }
};
